export default __webpack_public_path__ + "static/18_37-9b3c519faa7940f77020cc772b0f970d.png";